/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {DropMenuEl} from 'common/components/drop-menu';
import {InputEl} from 'common/components/input';
import {ButtonBarEl} from 'common/components/button-bar';
import {ButtonBarTheme} from 'common/components/button-bar/types';

import {TargetProjectSelectorMenuEl} from '../target-project-selector-menu';
import {CreateProjectModalEl} from '../create-project-modal';
import type {ProjectSelector} from './index';

export function template(this: ProjectSelector) {
  const {print} = this.getContext(`i18n`);
  const {searchFilter, isCreateProjectModalOpen} = this.state;
  return (
    <DropMenuEl
      attrs={{open: true, direction: this.params.direction, offset: this.params.offset}}
      props={{positionParent: this.params.positionParent}}
      on={{change: this.helpers.handleMenuChange}}
    >
      <div sel='.mp-project-selector-container'>
        <div sel='.mp-project-selector-search-container'>
          <InputEl
            attrs={{
              icon: `search`,
              placeholder: print(this.params.searchPlaceholder),
            }}
            on={{input: this.helpers.handleSearchInput}}
            props={{value: searchFilter}}
            hook={{insert: this.helpers.handleSearchInputInsertHook}}
          />
        </div>
        <TargetProjectSelectorMenuEl
          params={{
            isFeatureGateEnterpriseTier: false,
            projectSearchFilter: searchFilter,
            fillWidth: true,
          }}
          on={{
            projectSelected: this.helpers.handleProjectSelected,
          }}
        />
        <ButtonBarEl attrs={{theme: ButtonBarTheme.Secondary}} on={{click: this.helpers.handleOpenProjectModal}}>
          {print(this.params.submitCopy)}
        </ButtonBarEl>
      </div>
      {isCreateProjectModalOpen && (
        <CreateProjectModalEl
          attrs={this.helpers.getCreateProjectModalAttrs()}
          on={{cancel: this.helpers.handleCancelProjectModal, create: this.helpers.handleCreateProjectModal}}
        />
      )}
    </DropMenuEl>
  );
}
